// CONVENTION isFoo -> boolean

import { BigNumber } from "ethers";
import { getAddress } from "@ethersproject/address";

/**
 * Returns true if the string value is zero in hex
 * @param hexNumberString
 */
export function isZero(hexNumberString: string): boolean {
  return /^0x0*$/.test(hexNumberString);
}

export const isNilValue = (text: string) =>
  BigNumber.isBigNumber(text)
    ? BigNumber.from(text).isZero()
    : text === "" || text.replace(/0/g, "").replace(/\./, "") === "";

export function isAddress(value: any): string | false {
  try {
    return getAddress(value);
  } catch {
    return false;
  }
}

export const isZeroBigNumber = (value: any): value is undefined | null =>
  value?._isBigNumber
    ? isZero(value._hex)
    : typeof value === "undefined" || value === null || String(value) == "NaN";

export const isNil = (value: any): value is undefined | null =>
  typeof value === "undefined" || value === null || String(value) == "NaN";

export const isEmpty = (value: any): boolean => {
  if (isNil(value)) {
    return true;
  }
  if (typeof value === "object") {
    return Object.keys(value).length === 0;
  }
  return value.length === 0;
};

const inputRegex = RegExp(`^\\d*(?:\\\\[.])?\\d*$`); // m

export function escapeRegExp(string: string): string {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}

export const enforcer = (
  nextUserInput: string,
  onUserInput: (input: string) => void
) => {
  if (nextUserInput === "" || inputRegex.test(escapeRegExp(nextUserInput))) {
    onUserInput(nextUserInput);
  }
};
